import { singleItemWrapper, listWrapper } from '../../../api-client/wrappers'
import type { Starter } from '../../types/internal'
import type { CreateTokenBody, Platforms, Token } from './types'

export default {
  factory: ({ apiClient, version }) => {
    const tracking = listWrapper<'platform', Token>(apiClient, {
      path: `/api/v${version}/cs/tracking`,
      idKey: 'platform'
    })

    const { get: getPlatforms } = singleItemWrapper<Platforms>(apiClient, {
      path: `/api/v${version}/cs/tracking/platforms`
    })

    return {
      tracking,
      getPlatforms,
      startTracking: (payload: CreateTokenBody) =>
        apiClient.post(`/api/v${version}/cs/tracking/start`, { body: payload }),
      stopTracking: () => apiClient.post(`/api/v${version}/cs/tracking/stop`)
    }
  }
} satisfies Starter
